import React, { Component } from "react"
import { withStyles } from '@material-ui/core/styles';
import { TextField } from "@material-ui/core"
import Save from "../../../../assets/img/svg/save.svg"
import Cancel from "../../../../assets/img/svg/cancel.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery"
import { addprojectbasicinfo, getprojectbasicinfo, putprojectintroinfo } from "../../../../actions/AddNewProjectAction"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../_helpers/endpointService"
import del from "../../../../assets/img/svg/Del.svg"
class AddINTRO extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            menu: true,
            isEdit: false,
            cancel: false,
            ProjectName: "New Project",
            addData: {
                "ProjectId": 0,
                "ProjectIntroduction": "",
                "Modifiedby": "",
                "ActionBy": ""
            }
        }
    };

    componentDidMount() {
        window.location.pathname === "/introduction/add" ? this.state.isEdit = false : this.state.isEdit = true;
        this.state.ProjectName = localStorage.getItem("ProjectName");
        this.state.addData.Modifiedby = localStorage.getItem("UserRoles");
        this.state.addData.ActionBy = localStorage.getItem("UserRoles");
        this.setState({})
        if (this.state.isEdit == false) {
            if (localStorage.getItem("addeditid") != null) {
                this.getprojectbasicinfo(localStorage.getItem("addeditid"))
            }
        }
        if (this.state.isEdit == true) {
            this.getprojectbasicinfo(localStorage.getItem("DashId"))
        }
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    };

    getprojectbasicinfo = (data) => {
        let apiUrl = API.ADDEDIT_PROJECT + data;
        // this.props.dispatch({type:"SHOW_LOADER",data:true})
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.addData.ProjectId = response?.data.ProjectId;
                    this.state.addData.ProjectIntroduction = response.data?.ProjectIntroduction;
                    // this.state.addData.StatusId = response.data?.StatusId;
                    this.setState({})
                    // this.props.dispatch({type:"SHOW_LOADER",data:false})
                } else {
                    // this.props.dispatch({type:"SHOW_LOADER",data:false})
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#I .MuiListItemText-primary").removeClass("fw-bolder")
        $("#IL").removeClass("active-color")
    }

    // sidebar = () => {
    //     if (this.state.isEdit == true) {
    //         this.props.navigate("/sidebareditproject");
    //     }
    //     else {
    //         this.props.navigate("/sidebaraddproject");
    //     }
    // }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            if (this.state.isEdit == true) {
                this.props.navigate("/sidebareditproject");
            }
            else {
                this.props.navigate("/sidebaraddproject");
            }
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        if (this.state.isEdit == true) {
            this.props.navigate("/sidebareditproject");
        }
        else {
            this.props.navigate("/sidebaraddproject");
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Intro1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#Introduction1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Introduction").removeClass("d-none");
        $("#Introduction").addClass("d-block");
        $("#I .MuiListItemText-primary").addClass("fw-bolder");
        $("#IL").addClass("active-color");
    };

    handleInputChange = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.setState({})
        if (e.target.value.length - 1 < 3000) {
            this.state.addData.ProjectIntroduction = e.target.value;
            this.setState({});
        }
    };

    Save = () => {
        const { ProjectId, ProjectIntroduction } = this.state.addData
        if (ProjectId !== 0 || ProjectId !== undefined) {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.setState({ cancel: false })
            if (this.state.addData.ProjectIntroduction != "" || this.state.addData.ProjectIntroduction != null) {
                this.state.addData.ProjectIntroduction = this.state.addData.ProjectIntroduction.trim();
            }
            this.setState({})
            this.props.dispatch(putprojectintroinfo(this.state.addData, this.state.addData.ProjectId))
        } else {
            this.props.navigate(`/introduction/add`)
        }
    };

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/projectlist`)
        }
    }

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/projectlist`)
    };

    render() {
        const { isEdit } = this.state;
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100  mt-4">
                                <div className="col-7 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Intro" + "1"} className='textNaviIcon' primary={this.state.isEdit ? "Edit Project" : "New Project"} />
                                            <NavigateNextIcon id="Intro" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5 ">
                                    <h4 className="pt-2">Introduction</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                        <td className="border-right text-center" >
                                            <button className={`${classes.button}`} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        </td>
                                        <td className="text-center">
                                            <button className={`${classes.button} `} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                            <td className="" width="95%">
                                                <button className={`${classes.button}`} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table></>}
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">{this.state.ProjectName}</h6>}
                        <div className={this.state.isMobile ? "row mx-0" : "row mx-1 px-3 mt-2"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right d-flex"}>Introduction&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-10 col-xl-11  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 " : "col-md-10 pt-4 "}`}>
                                    <TextField
                                        multiline
                                        rows={28}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData?.ProjectIntroduction}
                                        onChange={(e) => { this.handleInputChange(e, "ProjectIntroduction") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.ProjectIntroduction?.length == undefined ? 3000 - 0 : 3000 - this.state.addData?.ProjectIntroduction?.length}/3000 Characters left</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div style={{ margin: this.state.isMobile ? "auto" : "15px 45px" }}>
                        <div className="row px-4">
                            {this.state.isMobile ? <></> : <h6 className="col-12">{this.state.ProjectName}</h6>}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 pt-3">
                                <label>Introduction :</label>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 pt-3">
                                <TextField
                                    multiline
                                    rows={28}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={this.state.addData?.ProjectIntroduction}
                                    onChange={(e) => { this.handleInputChange(e, "ProjectIntroduction") }}
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />
                                <lable className="float-end" style={{ opacity: '0.5' }}>{3000 - this.state.addData?.ProjectIntroduction?.length}/3000 Characters left</lable>
                            </div>

                        </div>
                    </div> */}
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        getprojectid: state.AddNewProjectReducer.getprojectid || [],
        getbasicinfo: state.AddNewProjectReducer.getbasicinfo || [],
    };
}

AddINTRO.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddINTRO))
);
